import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchInstallationsPredictedStatusResponse } from "./FetchInstallationsPredictedStatusResponse";
import { InstallationPredictedStatusEnum } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";
import { IFilterInstallations } from "../supportObjects/IFilterInstallations";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";
import { TagValues } from "@/model/data/Tag";

const ENDPOINT = "/predictive_maintenance/status";

export class FetchInstallationsPredictedStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetDevicesPredictedStatusReqData;

    constructor(payload: GetDevicesPredictedStatusReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<FetchInstallationsPredictedStatusResponse> {
        let res = await this.executeCommand(this.payload);
        return new FetchInstallationsPredictedStatusResponse(res);
    }
}

export class GetDevicesPredictedStatusReqData implements IFilterInstallations, IPaginationFilter {
    // FilterInstallations
    installationNames: string[] = null;
    folderIds: number[] = null;
    branchNames: string[] = [];

    // PaginationFilters
    queryLimit: number = 0;
    offset: number = 0;
    orderBy: string[] = null;
    orderByDescending: boolean[] = null;

    // Other filters
    predictedStatusFilter: InstallationPredictedStatusEnum[] = [];
    installationLastMessageDateRange: string[] = [];
    agentLastMessageDateRange: string[] = [];
    machineModels: string[] = null;
    tagValues: TagValues = null;
}
